import React, { useState, useEffect, useCallback } from 'react';
import { getBillingConfigPortal, updateBillingProfileImage } from '../../api';
import { FiUser, FiImage } from 'react-icons/fi';

export default function HostelAccountPortal({ hostel }) {
  const [profileImage, setProfileImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getBillingConfigPortal(hostel.id);
      setProfileImage(res.data.profile_image || null);
    } catch (e) {
      setError('Failed to load account details');
    }
    setLoading(false);
  }, [hostel.id]);

  useEffect(() => { load(); }, [load]);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setError(''); setSuccess('');
    const reader = new FileReader();
    reader.onload = async (ev) => {
      const dataUri = ev.target.result;
      setProfileImage(dataUri);
      try {
        await updateBillingProfileImage(hostel.id, dataUri);
        setSuccess('Profile picture updated — it will now appear on your invoices');
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to upload picture');
      }
    };
    reader.readAsDataURL(file);
  };

  return (
    <div className="card">
      <div className="card-header">
        <div>
          <h2 className="card-title"><FiUser /> Hostel Account</h2>
          <p style={{ margin: '4px 0 0' }}>Manage your hostel's profile</p>
        </div>
      </div>

      {error && <div className="alert alert-error">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      {loading ? (
        <div className="loading"><div className="spinner"></div></div>
      ) : (
        <div style={{ display: 'grid', gap: '20px', maxWidth: '520px' }}>
          <div>
            <label style={{ fontWeight: 600, fontSize: '13px', marginBottom: '8px', display: 'block' }}>Profile Picture</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <div style={{ width: '80px', height: '80px', borderRadius: '14px', overflow: 'hidden', background: 'rgba(255,255,255,0.06)', border: '1.5px solid rgba(255,255,255,0.12)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                {profileImage ? <img src={profileImage} alt={hostel.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <FiImage size={30} color="rgba(255,255,255,0.4)" />}
              </div>
              <label className="btn btn-primary btn-small" style={{ cursor: 'pointer' }}>
                Upload Picture
                <input type="file" accept="image/*" hidden onChange={handleImageUpload} />
              </label>
            </div>
            <p style={{ fontSize: '12px', marginTop: '8px' }}>This picture appears on every invoice generated for your hostel — individual and consolidated.</p>
          </div>

          <div className="page-container" style={{ marginBottom: 0 }}>
            <div style={{ fontSize: '11px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: '10px', color: 'rgba(255,255,255,0.45)' }}>Hostel Details</div>
            <div style={{ display: 'grid', gap: '8px', fontSize: '13.5px', color: 'rgba(255,255,255,0.85)' }}>
              <div><strong style={{ color: '#fff' }}>Name:</strong> {hostel.name}</div>
              <div><strong style={{ color: '#fff' }}>In-charge:</strong> {hostel.incharge_name}</div>
              <div><strong style={{ color: '#fff' }}>Email:</strong> {hostel.email}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
